import React from 'react';

interface PrivacyModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const PrivacyModal: React.FC<PrivacyModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  return (
    <div className="confirm-overlay" role="dialog" aria-modal="true">
      <div className="confirm-modal" style={{ maxWidth: 640, textAlign: 'left' }}>
        <h3>Privacy, Cookies, and Ads</h3>
        <p>
          Letterweave uses cookies and local storage to remember your game progress and preferences.
          We may show ads via Google AdSense. Ad partners may use cookies to personalize or measure ads.
        </p>
        <h4>What we store</h4>
        <ul>
          <li>Game state (grid, score, words found) in your browser only</li>
          <li>Debug preference (if enabled)</li>
          <li>Cookie consent status</li>
        </ul>
        <h4>Your choices</h4>
        <ul>
          <li>You can clear data anytime via your browser settings.</li>
          <li>You can disable personalized ads from Google via your Google Ad settings.</li>
        </ul>
        <div className="confirm-actions">
          <button className="confirm-accept" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyModal;


